import { AppBar } from '@material-ui/core'
import React from 'react'
import { headerBarStyle } from './layout.style'
import { ResponsiveBox } from './responsive-box.component'
import { Breadcumbs } from './breadcumbs.component'

export const HeaderBar = ({ children, className, ...props }) => {
	return (
		<AppBar css={headerBarStyle} className={`${className} 'no-back-link'`}>
			<ResponsiveBox position="relative" height="90px" {...props}>
				{children}
			</ResponsiveBox>
			{/* <Breadcumbs /> */}
		</AppBar>
	)
}
